module.exports = __webpack_public_path__ + "img/icon_3_42.bb779512.png";